// extracted by mini-css-extract-plugin
export default {"message":"Compilations_message__alDWc","loader":"Compilations_loader__HxgDj"};